import React from 'react';

import { TagSection, TagHeader, TagHeading, TagDescription, TagButton, TagWidget } from './styles';

const TagOnInstagram = () => (
  <TagSection>
    <TagHeader>
      <div>
        <TagHeading>Tag Us on Instagram</TagHeading>
        <TagDescription>
          Share your favorite way to daycation!<br />Tag yourself and see who’s in! <a href="https://www.instagram.com/dayaxeapp/?hl=en" target="_blank" rel="noopener noreferrer">#dayaxe</a>
        </TagDescription>
      </div>
      <TagButton href="https://www.instagram.com/dayaxeapp/?hl=en" target="_blank" rel="noopener noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
          <path fillRule="evenodd" d="M14 0H6a6 6 0 0 0-6 6v8a6 6 0 0 0 6 6h8a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6zm4 14a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8z" clipRule="evenodd" />
          <path fillRule="evenodd" d="M10 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM15 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" clipRule="evenodd" />
        </svg>
        Follow Us on Instagram
      </TagButton>
    </TagHeader>
    <TagWidget>
      <iframe src="https://snapwidget.com/embed/677678" title="DayAxe on Instagram" name="BookInsta" scrolling="no" className="snapwidget-widget" />
    </TagWidget>
  </TagSection>
);

export default TagOnInstagram;
